import { FC, useEffect } from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { getUploadUrl } from "@repo/edtech-api";
import { ImageModalViewer } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import { ExtendedLesson, TrackFn } from '../../../../model';
import { getConfig } from "../../../../origins";

import st from "./Photo.module.scss";

type Props = {
  lesson: ExtendedLesson,
  onFinishLesson: TrackFn,
  className?: string,
};

export const Photo: FC<Props> = ({
  lesson,
  onFinishLesson,
  className,
}) => {
  const { isImageWithModal } = getConfig();

  useEffect(() => {
    onFinishLesson(
      { type: AnalyticsEvent.Completed }, true, true,
    );
  }, [ onFinishLesson ]);

  return (
    <div className={clsx(st.wrap, className)}>
      <ImageModalViewer
        alt="img"
        className={st.image_trigger}
        disabledModal={!isImageWithModal}
        src={getUploadUrl(lesson?.file)}
      />
    </div>
  );
};
